import { useTheme } from 'styled-components'

import { ColorPicker, Text } from '@reveni-io/reveni-ui'

import ContrastIndicator from '@/common/components/ContrastIndicator/ContrastIndicator'

import * as Styles from './styles'

const AppearanceColorField = ({ field, label, recommendation, color, contrastColor, error, onChange, disabled }) => {
  const theme = useTheme()

  const handleChange = value => onChange(field, value)

  return (
    <Styles.Container>
      <ColorPicker
        label={label}
        recommendation={recommendation}
        defaultColor={color}
        onChange={handleChange}
        disabled={disabled}
      />
      {error && (
        <Text type="bodySRegular" color={theme.colors.danger.default}>
          {error}
        </Text>
      )}
      {contrastColor && <ContrastIndicator color={color} contrastColor={contrastColor} />}
    </Styles.Container>
  )
}

export default AppearanceColorField
